import { Component, OnInit } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { Router, ActivatedRoute, ChildActivationEnd } from '@angular/router';

@Component({
  selector: 'app-job-order-guide',
  templateUrl: './job-order-guide.component.html',
  styleUrls: ['./job-order-guide.component.scss']
})
export class JobOrderGuideComponent implements OnInit {
  public Databooking = <any>'';
  public DataGuestName = <any>'';
  public getDetails = <any>'';
  public privacy = <any>'';
  public privacy_ : boolean = false;
  public detail_spc : boolean = false;
  public guide = <any>'';
  public guide_tel = <any>'';
  public driver = <any>'';
  public driver_tel = <any>'';
  public DataHotel = <any>'';
  public DataHotelphone = <any>'';
  public Billerstatusnamelst : Array<any> = [];
  public _newArray : Array<any> = [];
  public pax : Array<any> = [];
  public round_pax : Array<any> = [];
  public count = <any>'';
  public _pax0 = <any>'';
  public _pax1 = <any>'';
  public _pax2 = <any>'';
  public _pax3 = <any>'';
  public _pax4 = <any>'';
  public _pax5 = <any>'';
  public _pax6 = <any>'';
  public _pax7 = <any>'';
  public _pax8 = <any>'';
  public _pax9 = <any>'';
  public _pax10 = <any>'';
  public _pax11 = <any>'';
  public _pax12 = <any>'';
  public row : Array<any> = [];
  public _hotelRoom : Array<any> = [];
  public _bookBy : Array<any> = [];
  public _payment: Array<any> = [];
  public _otacode: Array<any> = [];
  public _perPrice: Array<any> = [];
  public _perPriceChild: Array<any> = [];
  public _perPriceSum: Array<any> = [];
  public user = <any>'';
  public username = <any>'';
  public date = new Date();
  public noted = <any>'';
  public noted_check : boolean = false;
  

 // -------------------------- value join ----------------------------
  // variable of Details Join
  public time_pickup = "08.00";
  public cost = {
      foreigner : 300,
      child : 150,
      thai : 50,
      van_fee : 30,
      market : 40,
      vagetatian : <any>'',
      lunch : <any>''
  };
  public unit = {
      foreigner : <any>'',
      child : <any>'',
      thai : <any>'',
      van_fee : 1,
      market : <any>'',
      vagetatian : <any>'',
      lunch : <any>'',
      pax : <any>'',
      pax_of_vagetatian : <any>'',
      pax_of_lunch : <any>''
  };
  public amount = {
      foreigner : <any>'',
      child : <any>'',
      thai : <any>'',
      van_fee : <any>'',
      market : <any>'',
      vagetatian : <any>'',
      lunch : <any>'',
      sum : <any>''
  }

  // -------------------------- value private ----------------------------
  // variable of Details Private
  public cost_private = {
    foreigner : 300,
    child : 150,
    thai : 50,
    van_fee : 30,
    market : 40,
    vagetatian : <any>'',
    lunch : <any>''
};
public unit_private = {
    foreigner : <any>'',
    child : <any>'',
    thai : <any>'',
    van_fee : 1,
    market : <any>'',
    vagetatian : <any>'',
    lunch : <any>'',
    pax : <any>'',
    pax_of_vagetatian : <any>'',
    pax_of_lunch : <any>'',
};
public amount_private = {
    foreigner : <any>'',
    child : <any>'',
    thai : <any>'',
    van_fee : <any>'',
    market : <any>'',
    vagetatian : <any>'',
    lunch : <any>'',
    sum : <any>''
};
public detail_private_spc : any[] = [{
    detail_spc : '',
    unit_spc : '',
    cost_spc : '',
    amount_spc : '0'
}];


  constructor(
    private http: Http,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  // 1. print
  public print():void {
    window.print();
  }

  // 2. active menu
  public activeMenu(){
    // set storage
    sessionStorage.setItem('menu',JSON.stringify(4));
    sessionStorage.setItem('sub-menu',JSON.stringify(401));
  }

  // 3. get data Program Tour
public getDetailTours(){
  // post to API
  let url = "./../../../../assets/json/joborder/details_of_tours.json";
  let options = new RequestOptions();
  return this.http.get(url,options)
                  .map(res => res.json())
                  .subscribe(
                    data => [

                      this.getDetails= data,
                      
                    ],
                    err => [
                      console.log(err)
                    ]
                  );
}

  //4. get select book to create job order
  public getBookingSelect(){
    this.Databooking = sessionStorage.getItem('invoice_select');
    this.Databooking = JSON.parse(this.Databooking);

    let _guestName : Array<any> = [];
    // let _newArray : Array<any> = [];
    // push guest name in new array
      for(let i=0;i<=this.Databooking.length-1;i++){
        for(let j=0;j<=20;j++){
          if(this.Databooking[i].guestName[j]){
             _guestName.push(this.Databooking[i].guestName[j]);
          }
        }
      }

      // push hotel room in new array
      for(let i=0;i<=this.Databooking.length-1;i++){
            this._hotelRoom.push(this.Databooking[i].hotelRoom);
      }

      // push bookby in new array
      for(let i=0;i<=this.Databooking.length-1;i++){
             this._bookBy.push(this.Databooking[i].bookBy);
      }

      // push payment in new array
      for(let i=0;i<=this.Databooking.length-1;i++){
        if(this.Databooking[i].payment == 'E-Voucher'){
              this._payment.push(this.Databooking[i].payment);
            }else if(this.Databooking[i].payment == 'Voucher'){
                this._payment.push(this.Databooking[i].payment);
                  }else if(this.Databooking[i].payment == 'No Voucher'){
                      this._payment.push(this.Databooking[i].payment);
                        }else{
                          this._payment.push('Collect'+' '+'@'+' '+this.Databooking[i].payment);
                          }
         }

      // push perPrice in new array
      for(let i=0;i<=this.Databooking.length-1;i++){
            if(this.Databooking[i].childpax == 1 && this.Databooking[i].adultpax == 1 ){
                if(this.Databooking[i].payment == 'E-Voucher' || this.Databooking[i].payment == 'Voucher' || this.Databooking[i].payment == 'No Voucher' ){
                  this._perPrice.push('undefined');
                    }else{
                      this._perPrice.push(this.Databooking[i].adultprice +' + '+ this.Databooking[i].childprice +' = '+ this.Databooking[i].price);
                  }
            }else{
              if(this.Databooking[i].payment == 'E-Voucher' || this.Databooking[i].payment == 'Voucher' || this.Databooking[i].payment == 'No Voucher' ){
                  this._perPrice.push('undefined');
                  }else{
                         this._perPrice.push(this.Databooking[i].adultprice +' x '+ this.Databooking[i] .adultpax+ 'P = ' + this.Databooking[i].totaladultprice);
                  }
              }
      }

      // push perPrice - child in new array
      for(let i=0;i<=this.Databooking.length-1;i++){
            if(this.Databooking[i].childpax == 1 && this.Databooking[i].adultpax == 1 ){
              this._perPriceChild.push('undefined');
            }else if(this.Databooking[i].childpax >= 2){
                  if(this.Databooking[i].payment == 'E-Voucher' || this.Databooking[i].payment == 'Voucher' || this.Databooking[i].payment == 'No Voucher' ){
                      this._perPriceChild.push('undefined');
                  }else{
                      this._perPriceChild.push(this.Databooking[i].childprice+ ' x ' +this.Databooking[i].childpax+ 'P = ' +this.Databooking[i].totalchildprice);
                  }
            }else if(this.Databooking[i].adultpax >=2 && this.Databooking[i].childpax == 1 ){
                this._perPriceChild.push('+ '+this.Databooking[i].childprice+ ' = ' +this.Databooking[i].price);
            }
      }

      // push perPrice - child > 1 in new array
      for(let i=0;i<=this.Databooking.length-1;i++){
            if(this.Databooking[i].childpax >= 2){
              if(this.Databooking[i].payment == 'E-Voucher' || this.Databooking[i].payment == 'Voucher' || this.Databooking[i].payment == 'No Voucher' ){
                this._perPriceSum.push('undefined');
            }else{
                this._perPriceSum.push(' = ' +this.Databooking[i].price);
              }
            }else{
              this._perPriceSum.push('undefined');
            }
      }

      // push ota code in new array
      for(let i=0;i<=this.Databooking.length-1;i++){
            if(this.Databooking[i].payment !== 'E-Voucher'){
                    this._otacode.push('undefined');
            }else{
                    this._otacode.push(this.Databooking[i].otacode);
                  }
      }

        this.DataGuestName = _guestName;
        this.getDatanewArray_Hotel();
        this.setDatashowTable();

        //check privacy
        if(this.Databooking[0].tourPrivacy == "Join"){
            this.privacy_ = false;
        }else{
            this.privacy_ = true;
        }
  }

// set Data to show on Job Order Tables
  setDatashowTable(){
    // this._newArray.push({nameguest : this.DataGuestName[0],namehotel : this.DataHotel[0]});
    // this._newArray.push({nameguest : this.DataGuestName[1],namehotel : this.DataHotel[1]});
    // this._newArray.push({nameguest : this.DataGuestName[2],namehotel : this.DataHotel[2]});

  //  set loop for Round insert Hotel
    for(let i=0;i<=this.Databooking.length-1;i++){
            this.pax.push(this.Databooking[i].adultpax + this.Databooking[i].childpax + this.Databooking[i].infantpax);
      }
        let pax_ = this.pax;
        let sum_round = 0;
        for(let l=0;l<=this.pax.length-1;l++){             
            sum_round = sum_round + this.pax[l];
            this.round_pax.push(sum_round);
        }
        this.pax = this.round_pax;
        this.pax.pop();

        this._pax1 = this.round_pax[0];
        this._pax2 = this.round_pax[1];
        this._pax3 = this.round_pax[2];
        this._pax4 = this.round_pax[3];
        this._pax5 = this.round_pax[4];
        this._pax6 = this.round_pax[5];
        this._pax7 = this.round_pax[6];
        this._pax8 = this.round_pax[7];
        this._pax9 = this.round_pax[8];
        this._pax10 = this.round_pax[9];
        this._pax11 = this.round_pax[10];
        this._pax12 = this.round_pax[11];

    //set rowspan Hotel Data
        let q=0;
        for(let i=0;i<=this.DataGuestName.length-1;i++){
            this.round_pax.splice(0,0,0);
                  if(i == this.round_pax[q]){
                      this.row.push(pax_[q]);
                      q=q+1;
                  }else{
                      this.row.push(0);
                  }
                  this.round_pax.splice(0,1);
        }
        
    //insert Guest Hotel Room Agent Payment to Array
      for(let i=0;i<=this.DataGuestName.length-1;i++){
            if(i == 0){
              this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[i],room : this._hotelRoom[i],bookby : this._bookBy[i],hotelphone : this.DataHotelphone[i],payment : this._payment[i],otacode : this._otacode[i],perprice : this._perPrice[i],perpricechild : this._perPriceChild[i],perpricesum : this._perPriceSum[i]});
            }else{
              for(let j=1;j<=this.DataHotel.length;j++){
                for(let k=0;k<=this.pax.length;k++){
                    if(i == this.pax[k]){
                        this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j],room : this._hotelRoom[j],bookby : this._bookBy[j],hotelphone : this.DataHotelphone[j],payment : this._payment[j],otacode : this._otacode[j],perprice : this._perPrice[j],perpricechild : this._perPriceChild[j],perpricesum : this._perPriceSum[j]});
                    }else if(i == this.pax[k+1]){
                          this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+1],room : this._hotelRoom[j+1],bookby : this._bookBy[j+1],hotelphone : this.DataHotelphone[j+1],payment : this._payment[j+1],otacode : this._otacode[j+1],perprice : this._perPrice[j+1],perpricechild : this._perPriceChild[j+1],perpricesum : this._perPriceSum[j+1]});
                    }else if(i == this.pax[k+2]){
                          this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+2],room : this._hotelRoom[j+2],bookby : this._bookBy[j+2],hotelphone : this.DataHotelphone[j+2],payment : this._payment[j+2],otacode : this._otacode[j+2],perprice : this._perPrice[j+2],perpricechild : this._perPriceChild[j+2],perpricesum : this._perPriceSum[j+2]});
                    }else if(i == this.pax[k+3]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+3],room : this._hotelRoom[j+3],bookby : this._bookBy[j+3],hotelphone : this.DataHotelphone[j+3],payment : this._payment[j+3],otacode : this._otacode[j+3],perprice : this._perPrice[j+3],perpricechild : this._perPriceChild[j+3],perpricesum : this._perPriceSum[j+3]});
                    }else if(i == this.pax[k+4]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+4],room : this._hotelRoom[j+4],bookby : this._bookBy[j+4],hotelphone : this.DataHotelphone[j+4],payment : this._payment[j+4],otacode : this._otacode[j+4],perprice : this._perPrice[j+4],perpricechild : this._perPriceChild[j+4],perpricesum : this._perPriceSum[j+4]});
                    }else if(i == this.pax[k+5]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+5],room : this._hotelRoom[j+5],bookby : this._bookBy[j+5],hotelphone : this.DataHotelphone[j+5],payment : this._payment[j+5],otacode : this._otacode[j+5],perprice : this._perPrice[j+5],perpricechild : this._perPriceChild[j+5],perpricesum : this._perPriceSum[j+5]});
                    }else if(i == this.pax[k+6]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+6],room : this._hotelRoom[j+6],bookby : this._bookBy[j+6],hotelphone : this.DataHotelphone[j+6],payment : this._payment[j+6],otacode : this._otacode[j+6],perprice : this._perPrice[j+6],perpricechild : this._perPriceChild[j+6],perpricesum : this._perPriceSum[j+6]});
                    }else if(i == this.pax[k+7]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+7],room : this._hotelRoom[j+7],bookby : this._bookBy[j+7],hotelphone : this.DataHotelphone[j+7],payment : this._payment[j+7],otacode : this._otacode[j+7],perprice : this._perPrice[j+7],perpricechild : this._perPriceChild[j+7],perpricesum : this._perPriceSum[j+7]});
                    }else if(i == this.pax[k+8]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+8],room : this._hotelRoom[j+8],bookby : this._bookBy[j+8],hotelphone : this.DataHotelphone[j+8],payment : this._payment[j+8],otacode : this._otacode[j+8],perprice : this._perPrice[j+8],perpricechild : this._perPriceChild[j+8],perpricesum : this._perPriceSum[j+8]});
                    }else if(i == this.pax[k+9]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+9],room : this._hotelRoom[j+9],bookby : this._bookBy[j+9],hotelphone : this.DataHotelphone[j+9],payment : this._payment[j+9],otacode : this._otacode[j+9],perprice : this._perPrice[j+9],perpricechild : this._perPriceChild[j+9],perpricesum : this._perPriceSum[j+9]});
                    }else if(i == this.pax[k+10]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+10],room : this._hotelRoom[j+10],bookby : this._bookBy[j+10],hotelphone : this.DataHotelphone[j+10],payment : this._payment[j+10],otacode : this._otacode[j+10],perprice : this._perPrice[j+10],perpricechild : this._perPriceChild[j+10],perpricesum : this._perPriceSum[j+10]});
                    }else if(i == this.pax[k+11]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+11],room : this._hotelRoom[j+11],bookby : this._bookBy[j+11],hotelphone : this.DataHotelphone[j+11],payment : this._payment[j+11],otacode : this._otacode[j+11],perprice : this._perPrice[j+11],perpricechild : this._perPriceChild[j+11],perpricesum : this._perPriceSum[j+11]});
                    }else if(i == this.pax[k+12]){
                      this._newArray.push({nameguest : this.DataGuestName[i],namehotel : this.DataHotel[j+12],room : this._hotelRoom[j+12],bookby : this._bookBy[j+12],hotelphone : this.DataHotelphone[j+12],payment : this._payment[j+12],otacode : this._otacode[j+12],perprice : this._perPrice[j+12],perpricechild : this._perPriceChild[j+12],perpricesum : this._perPriceSum[j+12]});
                    }else{
                      this._newArray.push({nameguest : this.DataGuestName[i]});
                    }break;
                }break;
              } 
            } 
        }
  }

  getDatanewArray_Hotel(){
    let _hotel : Array<any> = [];
    //push hotel in new array
    for(let i=0;i<=this.Databooking.length-1;i++){
           _hotel.push(this.Databooking[i].hotel);
    }
      this.DataHotel = _hotel;
  

      let _hotelphone: Array<any> = [];
      //push hotel phone in new array
        for(let i=0;i<=this.Databooking.length-1;i++){
            _hotelphone.push(this.Databooking[i].hotelphone);
        }
          this.DataHotelphone = _hotelphone;
  }


    // ----------------------------------------------------------------------------|  Detail Join Process  |------------------------------------------------------------------------------------- 


  //5.set unit at details & process Amount
  public getunitBooking(){

    this.cost.vagetatian = 0;

    this.unit.thai = 0;

    //get adult_pax
    let adult_pax = 0;
      for(let i=0;i<=this.Databooking.length-1;i++){
        adult_pax = adult_pax + this.Databooking[i].adultpax;
      }
    //get chlid_pax
    let child_pax = 0;
      for(let i=0;i<=this.Databooking.length-1;i++){
        child_pax = child_pax + this.Databooking[i].childpax;
      }
      //get infant_pax
    let infant_pax = 0;
    for(let i=0;i<=this.Databooking.length-1;i++){
      infant_pax = infant_pax + this.Databooking[i].infantpax;
    }
    // all pax
    this.unit.pax = adult_pax + child_pax;
    this.count = this.unit.pax + infant_pax ;

    //set amount unit for Food Price
    this.unit.pax_of_lunch = this.unit.pax;
    this.unit.lunch = this.unit.pax;

    this.processPriceFood();

    //process Amount
      this.amount.foreigner = adult_pax * this.cost.foreigner;
      this.amount.child = child_pax * this.cost.child;
      this.amount.thai = this.unit.thai * this.cost.thai;
      this.amount.market = this.unit.pax * this.cost.market;
      this.unit.foreigner = adult_pax;
      this.unit.child = child_pax;
      this.amount.van_fee = this.cost.van_fee*this.unit.van_fee;
      this.amount.vagetatian = this.cost.vagetatian * 1;
      this.amount.lunch = this.cost.lunch * 1;
      this.amount.sum = this.amount.foreigner + this.amount.child + this.amount.market + this.amount.van_fee + this.amount.vagetatian + this.amount.lunch;
  }

  public changePrice(){
    this.amount.lunch = this.cost.lunch * 1;
    this.amount.vagetatian = this.cost.vagetatian * 1;
    this.amount.thai = this.unit.thai * this.cost.thai;
    this.amount.sum = this.amount.foreigner + this.amount.child + this.amount.market + this.amount.van_fee + this.amount.vagetatian + this.amount.lunch + this.amount.thai ;
  }

  public processPriceFood(){
        if(this.unit.pax_of_lunch == 2 && this.unit.pax_of_vagetatian == 2){         //lunch = 2 & vagetatian = 2,3,4,5,6,7 pax
            this.cost.lunch = 440;                                                  // lunch 400 bath
            this.cost.vagetatian = 440;                                             
        }if(this.unit.pax_of_lunch == 2 && this.unit.pax_of_vagetatian == 3){
            this.cost.lunch = 440;
            this.cost.vagetatian = 560;
        }if(this.unit.pax_of_lunch == 2 && this.unit.pax_of_vagetatian == 4 ){
          this.cost.lunch = 440;
          this.cost.vagetatian = 680;
        }if(this.unit.pax_of_lunch == 2 && this.unit.pax_of_vagetatian == 5 || this.unit.pax_of_lunch == 2 && this.unit.pax_of_vagetatian == 6 || this.unit.pax_of_lunch == 2 && this.unit.pax_of_vagetatian == 7){
          this.cost.lunch = 440;
          this.cost.vagetatian = 680;
        }if(this.unit.pax_of_lunch == 3 && this.unit.pax_of_vagetatian == 2 ){        //lunch = 3 & vagetatian = 2,3,4,5,6 pax
          this.cost.lunch = 600;                                                      // luch 600 bath
          this.cost.vagetatian = 680;                                                 
        }if(this.unit.pax_of_lunch == 3 && this.unit.pax_of_vagetatian == 3){
            this.cost.lunch = 600;
            this.cost.vagetatian = 560;
        }if(this.unit.pax_of_lunch == 3 && this.unit.pax_of_vagetatian == 4 ){
          this.cost.lunch = 600;
          this.cost.vagetatian = 680;
        }if(this.unit.pax_of_lunch == 3 && this.unit.pax_of_vagetatian == 5 || this.unit.pax_of_lunch == 2 && this.unit.pax_of_vagetatian == 6){
          this.cost.lunch = 600;
          this.cost.vagetatian = 680;
        }if(this.unit.pax_of_lunch == 4 && this.unit.pax_of_vagetatian == 2){         //lunch = 4 & vagetatian = 2,3,4,5 pax
            this.cost.lunch = 880;                                                   // lunch 880 bath
            this.cost.vagetatian = 440;                                              
        }if(this.unit.pax_of_lunch == 4 && this.unit.pax_of_vagetatian == 3){
            this.cost.lunch = 880;
            this.cost.vagetatian = 560;
        }if(this.unit.pax_of_lunch == 4 && this.unit.pax_of_vagetatian == 4 ){
          this.cost.lunch = 880;
          this.cost.vagetatian = 680;
        }if(this.unit.pax_of_lunch == 4 && this.unit.pax_of_vagetatian == 5){
          this.cost.lunch = 880;
          this.cost.vagetatian = 680;
        }if(this.unit.pax_of_lunch == 5 && this.unit.pax_of_vagetatian== 2){         //lunch = 5 & vagetatian = 2,3,4, pax
            this.cost.lunch = 1040;                                                  // lunch 1040 bath
            this.cost.vagetatian = 440;                                              
        }if(this.unit.pax_of_lunch == 5 && this.unit.pax_of_vagetatian == 3){
            this.cost.lunch = 1040;
            this.cost.vagetatian = 560;
        }if(this.unit.pax_of_lunch == 5 && this.unit.pax_of_vagetatian == 4 ){
          this.cost.lunch = 1040;
          this.cost.vagetatian = 680;
        }if(this.unit.pax_of_lunch == 6 && this.unit.pax_of_vagetatian == 2){         //lunch = 6 & vagetatian = 2,3 pax
            this.cost.lunch = 1360;                                                  // lunch 1360 bath
            this.cost.vagetatian = 440;                                              
        }if(this.unit.pax_of_lunch == 6 && this.unit.pax_of_vagetatian == 3){
            this.cost.lunch = 1360;
            this.cost.vagetatian = 560;
        }if(this.unit.pax_of_lunch == 7 && this.unit.pax_of_vagetatian == 2){         //lunch = 7 & vagetatian = 2 pax
            this.cost.lunch = 1610;                                                  // lunch 1610 bath
            this.cost.vagetatian = 440;                                              

    // Singel Style Food    

        }if(this.unit.pax_of_lunch  == 2 && this.unit.pax_of_vagetatian == 0){                                                  //lunch = 2 pax | lunch 440 bath
          this.cost.lunch  = 440;
          this.unit.vagetatian = 0;
        }if(this.unit.pax_of_lunch  == 3  && this.unit.pax_of_vagetatian == 0){                                                  //lunch = 3 pax | lunch 600 bath 
          this.cost.lunch  = 600;
          this.unit.vagetatian = 0;
        }if(this.unit.pax_of_lunch  == 4  && this.unit.pax_of_vagetatian == 0){                                                  //lunch = 4 pax | lunch 880 bath
          this.cost.lunch = 880;
          this.unit.vagetatian = 0;
        }if(this.unit.pax_of_lunch  == 5  && this.unit.pax_of_vagetatian == 0){                                                  //lunch = 5 pax | lunch 1040 bath
          this.cost.lunch = 1040;
          this.unit.vagetatian = 0;
        }if(this.unit.pax_of_lunch  == 6  && this.unit.pax_of_vagetatian == 0){                                                  //lunch = 6 pax | lunch 1360 bath
          this.cost.lunch  = 1360;
          this.unit.vagetatian = 0;
        }if(this.unit.pax_of_lunch  == 7  && this.unit.pax_of_vagetatian == 0){                                                  //lunch = 7 pax | lunch 1610 bath
          this.cost.lunch  = 1610;
          this.unit.vagetatian = 0;
        }if(this.unit.pax_of_lunch  == 8  && this.unit.pax_of_vagetatian == 0){                                                  //lunch = 8 pax | lunch 1760 bath
          this.cost.lunch  = 1760;
          this.unit.vagetatian = 0;
        }if(this.unit.pax_of_lunch  == 9  && this.unit.pax_of_vagetatian == 0){                                                  //lunch = 9 pax | lunch 1760 bath
          this.cost.lunch  = 1760;
          this.unit.vagetatian = 0;
        }if(this.unit.pax_of_lunch  == 2  && this.unit.pax_of_vagetatian == 0){                                                  //vagetatian = 2 pax | vagetatian 440 bath
          this.cost.vagetatian = 440;
          this.unit.lunch = 0;
        }if(this.unit.pax_of_vagetatian == 3 && this.unit.pax_of_lunch == 0){                                                   //vagetatian = 3 pax | vagetatian 600 bath 
          this.cost.vagetatian = 600;
          this.unit.lunch = 0;
        }if(this.unit.pax_of_vagetatian == 4  && this.unit.pax_of_lunch == 0){                                                  //vagetatian = 4 pax | vagetatian 880 bath
          this.cost.vagetatian = 880;
          this.unit.lunch = 0;
        }if(this.unit.pax_of_vagetatian == 5  && this.unit.pax_of_lunch == 0){                                                  //vagetatian = 5 pax | vagetatian 1040 bath
          this.cost.vagetatian = 1040;
          this.unit.lunch = 0;
        }if(this.unit.pax_of_vagetatian == 6  && this.unit.pax_of_lunch == 0){                                                  //vagetatian = 6 pax | vagetatian 1360 bath
          this.cost.vagetatian = 1360;
          this.unit.lunch = 0;
        }if(this.unit.pax_of_vagetatian == 7  && this.unit.pax_of_lunch == 0){                                                  //vagetatian = 7 pax | vagetatian 1610 bath
          this.cost.vagetatian = 1610;
          this.unit.lunch = 0;
        }if(this.unit.pax_of_vagetatian == 8  && this.unit.pax_of_lunch == 0){                                                  //vagetatian = 8 pax | vagetatian 1760 bath
          this.cost.vagetatian = 1760;
          this.unit.lunch = 0;
        }if(this.unit.pax_of_vagetatian == 9  && this.unit.pax_of_lunch == 0){                                                  //vagetatian = 9 pax | vagetatian 1760 bath
          this.cost.vagetatian = 1760;
          this.unit.lunch = 0;
        }
  }

  // ----------------------------------------------------------------------------|  Detail Private Process  |------------------------------------------------------------------------------------- 

  //5.set unit at details & process Amount
  public getunitBooking_(){
    //change unit vagetatian & lunch
    this.unit_private.vagetatian = 0;
    this.unit_private.pax_of_vagetatian = 0; 
    this.cost_private.vagetatian = 0;

    this.unit_private.thai = 0;

    //get adult_pax
    let adult_pax = 0;
      for(let i=0;i<=this.Databooking.length-1;i++){
        adult_pax = adult_pax + this.Databooking[i].adultpax;
      }
    //get chlid_pax
    let child_pax = 0;
      for(let i=0;i<=this.Databooking.length-1;i++){
        child_pax = child_pax + this.Databooking[i].childpax;
      }
      //get infant_pax
    let infant_pax = 0;
    for(let i=0;i<=this.Databooking.length-1;i++){
      infant_pax = infant_pax + this.Databooking[i].infantpax;
    }
    // all pax
    this.unit_private.pax = adult_pax + child_pax;

    this.unit_private.lunch = this.unit_private.pax ;
    this.unit_private.pax_of_lunch  = 2;

    this.processPriceFood_();

    //process Amount
      this.amount_private.foreigner = adult_pax * this.cost.foreigner;
      this.amount_private.child = child_pax * this.cost.child;
      this.amount_private.thai = this.unit.thai * this.cost.thai;
      this.amount_private.market = this.unit.pax * this.cost.market;
      this.unit_private.foreigner = adult_pax;
      this.unit_private.child = child_pax;
      this.amount_private.van_fee = this.cost.van_fee*this.unit.van_fee;
      this.amount_private.vagetatian = this.cost_private.vagetatian * 1;
      this.amount_private.lunch = this.cost_private.lunch * 1;
      this.amount_private.sum = this.amount_private.foreigner + this.amount_private.child + this.amount_private.market + this.amount_private.van_fee + this.amount_private.vagetatian + this.amount_private.lunch;
  }

  public changePrice_(){
    this.amount_private.lunch = this.cost_private.lunch * 1;
    this.amount_private.vagetatian = this.cost_private.vagetatian * 1;
    this.amount_private.thai = this.unit.thai * this.cost.thai;
    this.amount_private.sum = this.amount_private.foreigner + this.amount_private.child + this.amount_private.market + this.amount_private.van_fee + this.amount_private.vagetatian + this.amount_private.lunch + this.amount_private.thai;
    
    for(let i=0;i<=this.detail_private_spc.length;i++){
      this.detail_private_spc[i].amount_spc = this.detail_private_spc[i].unit_spc * this.detail_private_spc[i].cost_spc;
      this.amount_private.sum = this.amount_private.sum + this.detail_private_spc[i].amount_spc;
    }
  }

  public processPriceFood_(){
        if(this.unit_private.pax_of_lunch == 2 && this.unit_private.pax_of_vagetatian == 2){         //lunch = 2 & vagetatian = 2,3,4,5,6,7 pax
            this.cost_private.lunch = 440;                                                  // lunch 400 bath
            this.cost_private.vagetatian = 440;                                             
        }if(this.unit_private.pax_of_lunch == 2 && this.unit_private.pax_of_vagetatian == 3){
            this.cost_private.lunch = 440;
            this.cost_private.vagetatian = 560;
        }if(this.unit_private.pax_of_lunch == 2 && this.unit_private.pax_of_vagetatian == 4 ){
          this.cost_private.lunch = 440;
          this.cost_private.vagetatian = 680;
        }if(this.unit_private.pax_of_lunch == 2 && this.unit_private.pax_of_vagetatian == 5 || this.unit_private.pax_of_lunch == 2 && this.unit_private.pax_of_vagetatian == 6 || this.unit_private.pax_of_lunch == 2 && this.unit_private.pax_of_vagetatian == 7){
          this.cost_private.lunch = 440;
          this.cost_private.vagetatian = 680;
        }if(this.unit_private.pax_of_lunch == 3 && this.unit_private.pax_of_vagetatian == 2 ){        //lunch = 3 & vagetatian = 2,3,4,5,6 pax
          this.cost_private.lunch = 600;                                                      // luch 600 bath
          this.cost_private.vagetatian = 680;                                                 
        }if(this.unit_private.pax_of_lunch == 3 && this.unit_private.pax_of_vagetatian == 3){
            this.cost_private.lunch = 600;
            this.cost_private.vagetatian = 560;
        }if(this.unit_private.pax_of_lunch == 3 && this.unit_private.pax_of_vagetatian == 4 ){
          this.cost_private.lunch = 600;
          this.cost_private.vagetatian = 680;
        }if(this.unit_private.pax_of_lunch == 3 && this.unit_private.pax_of_vagetatian == 5 || this.unit_private.pax_of_lunch == 2 && this.unit_private.pax_of_vagetatian == 6){
          this.cost_private.lunch = 600;
          this.cost_private.vagetatian = 680;
        }if(this.unit_private.pax_of_lunch == 4 && this.unit_private.pax_of_vagetatian == 2){         //lunch = 4 & vagetatian = 2,3,4,5 pax
            this.cost_private.lunch = 880;                                                   // lunch 880 bath
            this.cost_private.vagetatian = 440;                                              
        }if(this.unit_private.pax_of_lunch == 4 && this.unit_private.pax_of_vagetatian == 3){
            this.cost_private.lunch = 880;
            this.cost_private.vagetatian = 560;
        }if(this.unit_private.pax_of_lunch == 4 && this.unit_private.pax_of_vagetatian == 4 ){
          this.cost_private.lunch = 880;
          this.cost_private.vagetatian = 680;
        }if(this.unit_private.pax_of_lunch == 4 && this.unit_private.pax_of_vagetatian == 5){
          this.cost_private.lunch = 880;
          this.cost_private.vagetatian = 680;
        }if(this.unit_private.pax_of_lunch == 5 && this.unit_private.pax_of_vagetatian == 2){         //lunch = 5 & vagetatian = 2,3,4, pax
            this.cost_private.lunch = 1040;                                                  // lunch 1040 bath
            this.cost_private.vagetatian = 440;                                              
        }if(this.unit_private.pax_of_lunch == 5 && this.unit_private.pax_of_vagetatian == 3){
            this.cost_private.lunch = 1040;
            this.cost_private.vagetatian = 560;
        }if(this.unit_private.pax_of_lunch == 5 && this.unit_private.pax_of_vagetatian == 4 ){
          this.cost_private.lunch = 1040;
          this.cost_private.vagetatian = 680;
        }if(this.unit_private.pax_of_lunch == 6 && this.unit_private.pax_of_vagetatian == 2){         //lunch = 6 & vagetatian = 2,3 pax
            this.cost_private.lunch = 1360;                                                  // lunch 1360 bath
            this.cost_private.vagetatian = 440;                                              
        }if(this.unit_private.pax_of_lunch == 6 && this.unit_private.pax_of_vagetatian == 3){
            this.cost_private.lunch = 1360;
            this.cost_private.vagetatian = 560;
        }if(this.unit_private.pax_of_lunch == 7 && this.unit_private.pax_of_vagetatian == 2){         //lunch = 7 & vagetatian = 2 pax
            this.cost_private.lunch = 1610;                                                  // lunch 1610 bath
            this.cost_private.vagetatian = 440;                                              

    // Singel Style Food    

        }if(this.unit_private.pax_of_lunch  == 2 && this.unit_private.pax_of_vagetatian == 0){                                                  //lunch = 2 pax | lunch 440 bath
          this.cost_private.lunch  = 440;
          this.cost_private.vagetatian = 0;
        }if(this.unit_private.pax_of_lunch  == 3  && this.unit_private.pax_of_vagetatian == 0){                                                  //lunch = 3 pax | lunch 600 bath 
          this.cost_private.lunch  = 600;
          this.cost_private.vagetatian = 0;
        }if(this.unit_private.pax_of_lunch  == 4  && this.unit_private.pax_of_vagetatian == 0){                                                  //lunch = 4 pax | lunch 880 bath
          this.cost_private.lunch = 880;
          this.cost_private.vagetatian = 0;
        }if(this.unit_private.pax_of_lunch  == 5  && this.unit_private.pax_of_vagetatian == 0){                                                  //lunch = 5 pax | lunch 1040 bath
          this.cost_private.lunch = 1040;
          this.cost_private.vagetatian = 0;
        }if(this.unit_private.pax_of_lunch  == 6  && this.unit_private.pax_of_vagetatian == 0){                                                  //lunch = 6 pax | lunch 1360 bath
          this.cost_private.lunch  = 1360;
          this.cost_private.vagetatian = 0;
        }if(this.unit_private.pax_of_lunch  == 7  && this.unit_private.pax_of_vagetatian == 0){                                                  //lunch = 7 pax | lunch 1610 bath
          this.cost_private.lunch  = 1610;
          this.cost_private.vagetatian = 0;
        }if(this.unit_private.pax_of_lunch  == 8  && this.unit_private.pax_of_vagetatian == 0){                                                  //lunch = 8 pax | lunch 1760 bath
          this.cost_private.lunch  = 1760;
          this.cost_private.vagetatian = 0;
        }if(this.unit_private.pax_of_lunch  == 9  && this.unit_private.pax_of_vagetatian == 0){                                                  //lunch = 9 pax | lunch 1760 bath
          this.cost_private.lunch  = 1760;
          this.cost_private.vagetatian = 0;
        }if(this.unit_private.pax_of_vagetatian  == 2  && this.unit_private.pax_of_lunch == 0){                                                  //vagetatian = 2 pax | vagetatian 440 bath
          this.cost_private.vagetatian = 440;
          this.cost_private.lunch = 0;
        }if(this.unit_private.pax_of_vagetatian == 3 && this.unit_private.pax_of_lunch == 0){                                                   //vagetatian = 3 pax | vagetatian 600 bath 
          this.cost_private.vagetatian = 600;
          this.cost_private.lunch = 0;
        }if(this.unit_private.pax_of_vagetatian == 4  && this.unit_private.pax_of_lunch == 0){                                                  //vagetatian = 4 pax | vagetatian 880 bath
          this.cost_private.vagetatian = 880;
          this.cost_private.lunch = 0;
        }if(this.unit_private.pax_of_vagetatian == 5  && this.unit_private.pax_of_lunch == 0){                                                  //vagetatian = 5 pax | vagetatian 1040 bath
          this.cost_private.vagetatian = 1040;
          this.cost_private.lunch = 0;
        }if(this.unit_private.pax_of_vagetatian == 6  && this.unit_private.pax_of_lunch == 0){                                                  //vagetatian = 6 pax | vagetatian 1360 bath
          this.cost_private.vagetatian = 1360;
          this.cost_private.lunch = 0;
        }if(this.unit_private.pax_of_vagetatian == 7  && this.unit_private.pax_of_lunch == 0){                                                  //vagetatian = 7 pax | vagetatian 1610 bath
          this.cost_private.vagetatian = 1610;
          this.cost_private.lunch = 0;
        }if(this.unit_private.pax_of_vagetatian == 8  && this.unit_private.pax_of_lunch == 0){                                                  //vagetatian = 8 pax | vagetatian 1760 bath
          this.cost_private.vagetatian = 1760;
          this.cost_private.lunch = 0;
        }if(this.unit_private.pax_of_vagetatian == 9  && this.unit_private.pax_of_lunch == 0){                                                  //vagetatian = 9 pax | vagetatian 1760 bath
          this.cost_private.vagetatian = 1760;
          this.cost_private.lunch = 0;
        }
  }

  // get user data
    public getUserData(){
      this.user = localStorage.getItem('users');
      this.user = JSON.parse(this.user);
      this.username = this.user.data.name;
  }

  //plus label detail job
  public add_private_spc() {
    if(this.detail_spc == false){
        this.detail_spc = true;
    }else{
    this.detail_private_spc.push({
      detail_spc: '',
      unit_spc: '',
      cost_spc: '',
      amount_spc: '0'
    });
    }
  }

  //get DATA Guide & Driver
    public getDataGuidesDirver(){
      let DataGuidesDirver;
      DataGuidesDirver = sessionStorage.getItem('guide_driver');
      DataGuidesDirver = JSON.parse(DataGuidesDirver);
      this.guide = DataGuidesDirver.data.Guide;
      this.driver = DataGuidesDirver.data.Driver;
      this.guide_tel = DataGuidesDirver.data.Phone_Guide;
      this.driver_tel = DataGuidesDirver.data.Phone_Driver;
    }


  removedetail(i: number) {
    this.detail_private_spc.splice(i, 1);
    this.changePrice_();
  }

  // Print Job Order
  joborder_print(){
    //check Noted not null
    if(this.noted == null || this.noted == undefined || this.noted == ''  ){
        this.noted_check = true;
        setTimeout(function(){ 
        window.print();
      }, 1000);

    }else{
        this.noted_check = false;
        setTimeout(function(){ 
          window.print();
        }, 1000);
    }
  }
    
  ngOnInit() {
      this.getDetailTours();
      this.getBookingSelect();
      this.getunitBooking();
      this.getunitBooking_();
      this.getUserData();
      this.getDataGuidesDirver();
  }
}
